export const DETAIL_SET = "DETAIL_SET"
export const DETAIL_SET_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const DETAIL_SET_ERROR = "FORGET_PASSWORD_ERROR"
//get country
export const DETAIL_GET_COUNTRY = "DETAIL_GET_COUNTRY"
export const DETAIL_GET_COUNTRY_SUCCESSFULL = "DETAIL_GET_COUNTRY_SUCCESSFULL"
export const DETAIL_GET_COUNTRY_FAILED = "DETAIL_GET_COUNTRY_FAILED"
//get state
export const DETAIL_GET_STATE = "DETAIL_GET_STATE"
export const DETAIL_GET_STATE_SUCCESSFULL = "DETAIL_GET_STATE_SUCCESSFULL"
export const DETAIL_GET_STATE_FAILED = "DETAIL_GET_STATE_FAILED"
//get ip location
export const DETAIL_GET_IP_LOCATION = "DETAIL_GET_IP_LOCATION"
export const DETAIL_GET_IP_LOCATION_SUCCESSFULL = "DETAIL_GET_IP_LOCATION_SUCCESSFULL"
export const DETAIL_GET_IP_LOCATION_FAILED = "DETAIL_GET_IP_LOCATION_FAILED"



//get country based on ip address
export const GET_COUNTRY_BY_IP="GET_COUNTRY_BY_IP"
export const GET_COUNTRY_BY_IP_SUCCESSFULL="GET_COUNTRY_BY_IP_SUCCESSFULL"
export const GET_COUNTRY_BY_IP_FAILED="GET_COUNTRY_BY_IP_FAILED"
export const GET_COUNTRY_AND_STATE="GET_COUNTRY_AND_STATE"
export const GET_COUNTRY_AND_STATE_SUCCESS="GET_COUNTRY_AND_STATE_SUCCESS"
export const GET_COUNTRY_AND_STATE_FAILED="GET_COUNTRY_AND_STATE_FAILED"


export const CAREER_PREVIEW_PROFILE_UPDATE="CAREER_PREVIEW_PROFILE_UPDATE"
export const CAREER_PREVIEW_PROFILE_UPDATE_SUCCESS="CAREER_PREVIEW_PROFILE_UPDATE_SUCCESS"
export const CAREER_PREVIEW_PROFILE_UPDATE_FAILURE="CAREER_PREVIEW_PROFILE_UPDATE_FAILURE"

export const SEND_TO_DEVELOPER="SEND_TO_DEVELOPER"
export const SEND_TO_DEVELOPER_SUCCESS="SEND_TO_DEVELOPER_SUCCESS"
export const SEND_TO_DEVELOPER_FAILURE="SEND_TO_DEVELOPER_FAILURE"
